import { render } from "./UserList.vue?vue&type=template&id=0fb427da&scoped=true"
import script from "./UserList.js?vue&type=script&lang=js&external"
export * from "./UserList.js?vue&type=script&lang=js&external"

import "./UserList.scss?vue&type=style&index=0&id=0fb427da&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb427da"]])

export default __exports__